import React from "react";
import {Breadcrumb, Button, Col, Divider, Form, Input, Row, Tabs, Typography} from "antd";
import and from "../../assets/img/and.png";
import ios from "../../assets/img/ios-er.png";
import login from "../../assets/img/login.png";
import login1 from "../../assets/img/login1.png";
import BaseComponent from "../../redare/components/BaseComponent";
import {Link} from "react-router-dom";
import RedoOutlined from "@ant-design/icons/lib/icons/RedoOutlined";


const {Title, Paragraph} = Typography;

export default class AppDownloadPage extends BaseComponent {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="AppDownload-Page">
                <div className="margin24">
                    <Link to="/">
                        <Button level={3} style={{textAlign:'right',float: 'right'}}>
                            <RedoOutlined />返回</Button>
                    </Link>
                    <Title level={3} className="text-alignC">数据开投APP 下载及登录说明 </Title>

                    <Divider/>
                    <Row gutter={[16, 24]}>
                        <Col span={24}>
                            <Title level={4}>一、数字开投APP 下载（扫码下载）</Title>
                        </Col>
                        <Col span={12}>
                            <div className="text-alignC">
                                <p style={{fontSize: 14, color: '#000'}}>安卓APP下载(使用手机浏览器扫码)</p>
                                <img src={and} className="border"/>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="text-alignC">
                                <p style={{fontSize: 14, color: '#000'}}>ios APP 下载（苹果端）</p>
                                <img src={ios} className="border"/>
                            </div>
                        </Col>
                        <Col>
                            <p>温馨提示:</p>
                            <p>1、ios APP 扫码时请使用苹果自带扫码工具进行扫码</p>
                            <p>2、苹果手机APP更新时仅需在APP Store内 个人账号下的已购项目内进行更新即可</p>
                        </Col>
                    </Row>
                    <Row gutter={[16, 24]}>
                        <Col span={24}>
                            <Title level={4}>二、数据开投APP 登录说明</Title>
                        </Col>
                        <Col span={12}>
                            <div className="text-alignC">
                                <p style={{fontSize: 14, color: '#000'}}>1.手机验证码登录</p>
                                <p style={{fontSize: 14, color: '#000'}}>输入手机号码，发送验证码并填写进行登录</p>
                                <img src={login1} className="border"/>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="text-alignC">
                                <p style={{fontSize: 14, color: '#000'}}>2.账号密码登录（以下2种方式均能登录）</p>
                                <p style={{fontSize: 14, color: '#000'}}>账号可使用OA账号或统一门户用户账号登录</p>
                                <img src={login} className="border"/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

        )
    }
}
